import { isBrowser } from '../window';

export function redirectToWithPageReload(pathName: string) {
  return isBrowser() && window.location.assign(pathName);
}
